// DISCLAIMER: these cookies are used by old car also, change with extra caution
export const POLICY_COOKIE_NAME = 'policy'

export const COOKIE_BANNER_COOKIE_NAME = 'cookiewarning'

export const PLOT_COOKIE_BANNER_COOKIE_NAME = 'cookieDisclaimer' // same as plot1
